import "./carousel.css";
import { useNavigate } from "react-router-dom";
import React, { useState } from "react";
import { ROLES } from '../../common/constants';
import { Container, Card, Button, CardContent, FormGroup, FormControlLabel, Checkbox, Stack, Box, Typography, Grid, FormControl, InputLabel, Select, MenuItem, TextField } from '@mui/material';
import { PROD } from "../../common/constants";
import SendIntimation from './sendIntimation';
import Excel_Upload from './upload_excel';
import { Download as  DownloadIcon } from '@mui/icons-material';
import { ProceedIcon } from "../../common/icons";

const waitlisted_logo = {
    width: "4vw",
    height: "8vh",
    top: "0vw",
    left: "0vw"
}

export default function Registration() {
    const [waitlistedlist, setWaitlistedlist] = useState();
    let userRoles = localStorage.getItem('role');
   
    function importAll(r) {
        let images = {};
        r.keys().map((item, index) => { images[item.replace('./', '')] = r(item); });
        return images;
    }
    const images = importAll(require.context('../../images/', false, /\.(png|jpe?g|svg)$/));
    const navigate = useNavigate();

    const onUploadClick = (e) => {
        e.preventDefault();
        navigate('/registrationHome/preregistration/excelupload');
    }

    const onProceedClick = (e) => {
        e.preventDefault();
        navigate('/registrationHome/preregistration/webRegSidebar');
    }

    const sendIntimation = (e) => {
        e.preventDefault();
        navigate('/registrationHome/preregistration/sendintimation');
    }
    return (
        <>
        <Container maxWidth="xxl">
        {!PROD &&   <p style={{textAlign:"center", fontSize:"2vh"}}>REG53</p>}
            <Typography variant="h5" gutterBottom>
                Pre-Registration Camps
            </Typography>
            <Grid container spacing={2} direction="row">
            {userRoles === ROLES.RegInCharge && <Grid item xs={12} lg={6}>
                    <SendIntimation />
                </Grid>}
                {userRoles === ROLES.RegInCharge && <Grid item xs={12} lg={6}>
                    <Excel_Upload />
                </Grid>}
                <Grid item xs={12} lg={6}>
                <Card>
                <CardContent>
                    <Typography variant="h6" style={{ marginBottom: "1em" }} gutterBottom>
                        Stakeholder Pre-registration
                    </Typography>
                    {userRoles != ROLES.RegInCharge && <a style={{ display: "flex", flexDirection: "row" }} href='https://abrplscmsandbox.blob.core.windows.net/stakeholdertemplate/StakeHolderMasterTemplate.xlsm'>
                        <DownloadIcon /> <Typography variant="subtitle1">Download Pre-registration Template.</Typography></a>}
                    <Box display='flex' alignItems="center" justifyContent="flex-end" mt={3}>
                        <Button endIcon={<ProceedIcon/>} variant="contained" sx={{ minWidth: 100 }} name="submit" onClick={(e) => onProceedClick(e)}>Proceed</Button>
                    </Box>
                    </CardContent>
                    </Card>
                </Grid>
            </Grid>
        </Container>
    </>
    );
}